import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { responsiveStoreEnhancer } from 'redux-responsive';
import { Iterable } from 'immutable';
import throttle from 'lodash/throttle';

import reducers from './reducerProvider';
import { loadState, saveState } from './localStorage';

const stateTransformer = (state) => {
    if (Iterable.isIterable(state)) return state.toJS();
    else return state;
};
const loggerMiddleware = createLogger({ stateTransformer, collapsed: true });

const enhancer = process.env.NODE_ENV !== 'production' ?
  composeWithDevTools(
    responsiveStoreEnhancer,
    applyMiddleware(thunkMiddleware, loggerMiddleware)
  ) : compose(
    responsiveStoreEnhancer,
    applyMiddleware(thunkMiddleware)
  );

const persistedState = loadState();
const store = createStore(reducers, persistedState, enhancer);

const minUpdateFrequency = 1000;
store.subscribe(throttle(() => {
  saveState({ oidc: store.getState().get('oidc') });
}, minUpdateFrequency));

export default store;
